import axios from "axios"

/** Uploads a single file straight to S3 through a presigned URL, reporting progress. */
export const uploadFileToS3 = async (
	url: string,
	file: File,
	onProgress?: (progress: number) => void,
): Promise<void> => {
	await axios.put(url, file, {
		headers: { "Content-Type": file.type },
		onUploadProgress: (event) => {
			if (event.total && onProgress) {
				onProgress(Math.round((event.loaded * 100) / event.total))
			}
		},
	})
}
